<template>
  <b-modal
    v-model="show"
    :title="row ? `Edit row ${row.index + 1}` : 'Add row'"
    centered
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    @ok="ok"
    @cancel="cancel"
    @close="cancel"
    header-class="bg-purple"
  >
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="secondary" @click="cancel()">
        Cancel
      </b-button>
      <b-button variant="primary" @click="ok()">
        Save
      </b-button>
    </template>

    <b-form-group v-for="field in fields" :key="field.key" :label="field.label">
      <v-select
        v-if="field.type == 'select'"
        :options="field.options"
        v-model="form[field.key]"
      />
      <date-picker v-else-if="field.type == 'date'" v-model="form[field.key]" />
      <time-picker v-else-if="field.type == 'time'" v-model="form[field.key]" />
      <b-input v-else v-model="form[field.key]" />
    </b-form-group>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import {
  formatDateOnlyMysql,
  formatDateTimeSql,
  formatTimeOnlyMysql
} from "../../../../helpers/date";
import DatePicker from "../../../controls/DatePicker.vue";
import TimePicker from "../../../controls/TimePicker.vue";
export default {
  name: "DatatableV1RowAddEditModal",
  components: { DatePicker, TimePicker },
  props: ["fields", "row", "show"],
  data() {
    return {
      form: {}
    };
  },
  mounted() {
    if (this.row) {
      this.form = { ...this.row.item };
      this.fields.forEach(field => {
        if (field.type == "time") {
          this.form[field.key] = formatTimeOnlyMysql(this.form[field.key]);
        }
      });
    }
  },
  methods: {
    ok(e) {
      e.preventDefault();
      this.fields.forEach(field => {
        if (field.type == "time") {
          this.form[field.key] = formatDateTimeSql(
            formatDateOnlyMysql(this.getCurrentAdjustedDateTime()) +
              "T" +
              this.form[field.key]
          );
        }
      });
      this.$emit("ok", { data: this.form, index: this.row?.index });
    },
    cancel(e) {
      e.preventDefault();
      this.$emit("cancel");
    }
  },
  computed: {
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"])
  }
};
</script>

<style></style>
